import script from "./DetalleDigitalySostenible.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalleDigitalySostenible.vue?vue&type=script&setup=true&lang=js"

import "./DetalleDigitalySostenible.vue?vue&type=style&index=0&id=58db087a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58db087a"]])

export default __exports__